// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenList_wrapper__3bccy"};